
import { useState, useEffect } from "react";
import { useWalletConnection } from "@/wallet";
import { ArrowDown, CircleDollarSign, DollarSign, Rocket, Users } from "lucide-react";
import Hero from "@/components/Hero";
import TokenomicsSection from "@/components/TokenomicsSection";
import Roadmap from "@/components/Roadmap";
import CinematicLore from "@/components/CinematicLore";
import OceanImpact from "@/components/OceanImpact";
import JoinSection from "@/components/JoinSection";
import Footer from "@/components/Footer";

const Index = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const { handleConnect } = useWalletConnection();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1F2C] to-[#0E1116] text-white overflow-x-hidden">
      {/* Hero Section */}
      <Hero onConnectWallet={handleConnect} />

      {/* The Lore Section - Now using CinematicLore */}
      <CinematicLore />

      {/* Tokenomics Section */}
      <TokenomicsSection />

      {/* Ocean Impact Section */}
      <OceanImpact />

      {/* Roadmap Section */}
      <Roadmap />

      {/* Join the Gang Section */}
      <JoinSection onConnectWallet={handleConnect} />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Index;
